import axios from '@/utils/fetch'
const _module = `basics/v1.0`;

export default {
  /**
   * 获取七牛token
   */
  getQiniuToken() {
    return axios({
      url: `${_module}/qiniu/token?type=1`,
    })
  }
}



// WEBPACK FOOTER //
// ./src/apis/src/basic.js